import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogramarchived/order/";

export default class OrderApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getOrders(params) {
    return await request.post(`${rootRoute}getOrders`, {
      filter: params,
      parameters: {},
    });
  }
  async getOrderById(id) {
    return await request.post(`${rootRoute}getOrders`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createOrder(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createOrder`, { data });
  }
  async deleteOrder(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteOrder`, { data });
  }
  async editOrder(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateOrder`, { data });
  }
  async import(gfid) {
    return await request.post(`${rootRoute}importOrder`, {
      gfid: gfid
    });
  }
  async getImportScaffold() {
    return await request.post(`${rootRoute}getOrderimporttemplate`, null, {responseType: 'blob'});
  }
  async export(filter, format) {
    return await request.post(`${rootRoute}exportOrder`, {
      filter: filter,
      format: format
    });
  }
  async publish(marsperiodId) {
    return await request.post(`${rootRoute}publishorder`, {
      marsperiodId: marsperiodId
    });
  }
  async approve(marsperiodId) {
    return await request.post(`${rootRoute}approveorder`, {
      marsperiodId: marsperiodId
    });
  }
  async confirm(marsperiodId) {
    return await request.post(`${rootRoute}confirmorder`, {
      marsperiodId: marsperiodId
    });
  }
  async getOrder(marsperiodId) {
    return await request.post(`${rootRoute}getOrder`, {
      marsperiodId: marsperiodId
    });
  }
  async checkPublish(marsperiodId) {
    return await request.post(`${rootRoute}checkPublish`, {
      marsperiodId: marsperiodId
    });
  }
}
